import { categoryConst } from "../constants/categoryConst";

const initialState = {
  items: [],
  loading: false,
  error: {},
  views: [],
  catList: {},
  catData: {},
  parentcatdata: [],
  catdetails: {},
  updatecat: {}
};
let items = [];
const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case categoryConst.ADD_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.ADD_CATEGORY_SUCCESS:
      return { ...state, loading: false, add: action.category };
    case categoryConst.ADD_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.error };
    case categoryConst.VIEW_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.VIEW_CATEGORY_SUCCESS:
      items["cviews"] = action.category;
      return items;
    case categoryConst.VIEW_CATEGORY_FAILURE:
      return {
        error: action.error
      };
    case categoryConst.VIEW_SUB_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.VIEW_CATEGORY_DETAIL_SUCCESS:
      return { ...state, catdetails: action.category };
    case categoryConst.VIEW_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case categoryConst.VIEW_CATEGORY_DETAIL:
      return {
        loading: true
      };
    case categoryConst.VIEW_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        views: action.data
      };
    case categoryConst.VIEW_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case categoryConst.VIEW_SECONDSUB_CATEGORY_SUCCESS:
      return {
        ...state,
        views: action.data
      };
    case categoryConst.VIEW_SECONDSUB_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case categoryConst.VIEW_ALL_CATEGORY_REQUEST:
      return {
        loading: true
      };
    case categoryConst.VIEW_ALL_CATEGORY_SUCCESS:
      return { ...state, catData: action.allcategory };
    case categoryConst.VIEW_ALL_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case categoryConst.STATUS_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.STATUS_CATEGORY_SUCCESS:
      return { ...state, status: action.category };
    case categoryConst.STATUS_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case categoryConst.DELETE_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.DELETE_CATEGORY_SUCCESS:
      return { ...state, delete: action.category };
    case categoryConst.DELETE_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case categoryConst.UPDATE_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.UPDATE_CATEGORY_SUCCESS:
      return { ...state, updatecat: action.category };
    case categoryConst.UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case categoryConst.VIEW_PARENT_CATEGORY:
      return {
        loading: true
      };
    case categoryConst.VIEW_PARENT_CATEGORY_SUCCESS:
      return { ...state, parentcatdata: action.pcategory.data };
    case categoryConst.VIEW_PARENT_CATEGORY_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
};
export default categoryReducer;



// WEBPACK FOOTER //
// ./src/app/redux/reducers/categoryReducer.js